import { toast } from "react-toastify";
import { useEffect, useRef, useState } from "react";

const googleLogin = async (accessToken: string) => {
  try {
    // Store token in sessionStorage
    sessionStorage.setItem("googleToken", accessToken);
    sessionStorage.setItem("ppEnabled", "true");
    toast.success("PP enabled");
    setTimeout(() => {
      window.location.reload();
    }, 1000);
    return accessToken;
  } catch (error: any) {
    toast.error(error?.message || "Failed to login with Google");
    throw error;
  }
};

export const useGoogleLoginApi = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [isError, setIsError] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);
  const [data, setData] = useState<any>(null);
  const [count, setCount] = useState(0);
  const [isEnabled, setIsEnabled] = useState(false);

  const handlePPLogin = () => {
    setCount(count + 1);
  };

  const login = {
    onSuccess: async (tokenResponse: any) => {
      console.log("tokenResponse", tokenResponse);
      try {
        setIsLoading(true);
        setIsError(false);
        setError(null);
        const credentials = await tokenResponse.credential;
        await googleLogin(credentials);
        setData(tokenResponse);
        setIsSuccess(true);
      } catch (err) {
        setIsError(true);
        setError(
          err instanceof Error ? err.message : "Failed to login with Google"
        );
        setIsSuccess(false);
        return { success: false };
      } finally {
        setIsLoading(false);
      }
    },
    onError: () => {
      setIsLoading(false);
      setIsError(true);
      setIsSuccess(false);
      setError("Google login error");
      setData(null);
      toast.error("Google login error");
      return { success: false };
    },
  };

  useEffect(() => {
    if (count === 10 && !sessionStorage.getItem("ppEnabled")) {
      setIsEnabled(true);
      setTimeout(() => {
        setCount(0);
      }, 1000);
    } else if (count === 10 && sessionStorage.getItem("ppEnabled")) {
      sessionStorage.removeItem("googleToken");
      sessionStorage.removeItem("ppEnabled");
      toast.info("PP disabled");
      setIsLoading(true);
      setCount(0);
      setTimeout(() => {
        console.log("reload");
        setIsLoading(false);
        window.location.reload();
      }, 1000);
      // setIsLoading(false);
    }
  }, [count]);

  return {
    handlePPLogin,
    isLoading,
    setIsLoading,
    error,
    isError,
    isSuccess,
    data,
    isEnabled,
    setIsEnabled,
    login,
  };
};
